var _image, _image2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupedwave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1441,
    height: 176,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "img_0",
    x: 0,
    y: 0,
    width: 1264,
    height: 106,
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI2NCIgaGVpZ2h0PSIxMDYiIHZpZXdCb3g9IjAgMCAxMjY0IDEwNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzOS40OTIgNTguNjA1NkwzMzkuODgzIDg3LjYxMTVMNTk0LjAyNiA2NS4yOTM5TDc2Mi4yODUgOTUuMjI1M0w4NjYuODY4IDEwNkwxMDE3LjY0IDYyLjkwMTVMMTE3My4xNiA5NC4xNjAxTDEyNDcuNTYgNzYuNDUyN0wxMjY0IDgzLjE0MUMxMjYyLjQ3IDc4Ljc0MDMgMTI2MC42NiA3NC40MDk2IDEyNTguNjggNzAuMDYxM0wxMjUzLjc2IDcyLjI2MTZMMTIxMi45IDQxLjAzNzlMMTA0NC43NiA1MC45OTE4TDk4Ny4xMjggMjEuODExMkw4NzIuODMyIDcxLjMzNjFMNzYxLjUxOSAyOS4xODA2TDYxMi40MDMgNTguNjA1Nkw1NjQuODg4IDQ5Ljg3NDFMNDMzLjYyNSAyOS4wNDA4TDI4OC44NjIgNTEuMTE0TDM2LjY1NCAwQy02IDczLjUgMC41MDAyNzQgMjEuNSAwLjUwMDExNCA3Ny4zMDM4TDIzOS40OTIgNTguNjA1NloiIGZpbGw9IiNENURCN0UiLz4KPC9zdmc+Cg==",
    opacity: 1
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "img_1",
    x: 1,
    y: 40,
    width: 1440,
    height: 136,
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSIxMzYiIHZpZXdCb3g9IjAgMCAxNDQwIDEzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0NDIgNzkuNTI2N0MxNDQyLjAxIDYxLjg0OTUgMTQzOS4xOCA0NC4xOTc2IDE0MzMuNTQgMjYuNzI0NUwxNDE3LjE3IDE5LjQzOTRMMTM0Mi45OCAzOC43MjY3TDExODguMDQgNC42NzkxNEwxMDM4LjE2IDUxLjYyMjlMOTM0LjA4NyAzOS44ODdMNzY2LjY0MSA3LjI4NTAxTDUxMy43MjcgMzEuNTkzOEw0MTMuODIgMEwzOS45ODQgMzIuMDUwM0wtMC41IDZDLTAuNDk5OTU5IDQ1IC0wLjUwMDExNiA2MC41IC0wLjUgMTM1LjYwMUgxNDMyLjQxQzE0MzguOCAxMTcuMDYzIDE0NDIuMDEgOTguMzEwMiAxNDQyIDc5LjUyNjdaIiBmaWxsPSIjQTRBQTQwIi8+Cjwvc3ZnPgo=",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupedwave);
export default __webpack_public_path__ + "static/media/groupedwave.09a2896654f37e5fc96fd0dd72345854.svg";
export { ForwardRef as ReactComponent };